import React, {useContext} from "react"
import { OverlayTrigger, Popover } from 'react-bootstrap';
import short from "short-uuid"
import LoginForm from "../LoginForm/LoginForm";
import { UserContext } from './../../utils/usermanagement'
import { ParentAPIContext } from './../../utils/parentapi'
import "./AccountPanel.scss";
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from "gatsby";


const hideAccountPanel = () => {
	document.body.click()
}

const collapseNavigation = () => {
	const menuToggle = document.querySelector('#mainNav .navbar-toggler');
	const navBarCollapse = document.getElementById('navbarSupportedContent');

	if(navBarCollapse && navBarCollapse.classList && navBarCollapse.classList.contains('show')) {
		menuToggle.click();
	}
}


const ChildNames = () => {
	const {parentChildren} = useContext(ParentAPIContext);
	const [childrenList, setChildrenList] = parentChildren;  // eslint-disable-line no-unused-vars
	const translator = short();

	if(childrenList && childrenList.allChildren && childrenList.allChildren.length) {

		const cardsHeader = <div className="childrenLength">{childrenList.allChildren.length} Children</div>

		const cards = childrenList.allChildren.map((child, index) => {
			return (
				<li key={index}><Link to={`/dashboard?child=`+ translator.fromUUID(child.child)} onClick={hideAccountPanel} data-analytics={`{ "event" : "child_progress", "actionType" : "CTA Click", "loginStatus": "logged-in", "clickText" : "${child.nickname}", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}${`/dashboard?child=`+ translator.fromUUID(child.child)}", "pageName" : "Parent - Homepage" , "moduleName" : "logged-in-pannel", "userType" : "parent" }`} >{child.nickname}</Link></li>
			)
		});

		return <> {cardsHeader} <ul>{cards}</ul></>;
	}

	return <><div className="childrenLength">0 children added</div></>;
}

const CurrentAccountpanel = () => {

	const [userState, userDispatch] = useContext(UserContext);

	if(userState?.cognito_user?.attributes) {
		return (
			<div className="logged-in-pannel">
				<h4>{userState.cognito_user.attributes.given_name}&nbsp;{userState.cognito_user.attributes.family_name}</h4>
				<ChildNames />
				<div className="account-btn-wrapper"><Link to={`/account/`} className="btn btn-primary d-block" data-analytics={`{ "event" : "parent_profile", "actionType" : "CTA Click", "loginStatus": "logged-in", "clickText" : "View account", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}/account/", "pageName" : "Parent - Homepage" , "moduleName" : "logged-in-pannel", "userType" : "parent" }`} >View account</Link></div>
				<div className="logout-link-wrapper">
					<Link to={`/register/`} className="link link-primary arrow small"
						onClick={(e) =>  { userDispatch({ action: "logout" }); hideAccountPanel(); }} data-analytics={`{ "event" : "parent_logout", "actionType" : "Link Click", "loginStatus": "logged-in", "clickText" : "Log out", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}/register/", "pageName" : "Parent - Homepage" , "moduleName" : "logged-in-pannel", "userType" : "parent" }`}>Log out</Link></div>
						</div>
		)
	}

	return <LoginForm engagement={"Account overlay"}/>
}


const AccountPanel = ({ pageTitle }) => {

	const [userState, userDispatch] = useContext(UserContext);
	const accountLinklabel = (userState?.cognito_user?.attributes)?"Account":"Log in";
	const loginStatus = accountLinklabel === "Account" ? "logged-in" : "logged-out";
	const linkUrl = process.env.GATSBY_APP_DOMAIN;
	const rollType = loginStatus === "logged-in" ? "parent" : "anonymous";

	return (
		<Dropdown id="popover-account">
			<Dropdown.Toggle className="nav-link link account-link" data-analytics={`{"event":"Navigation_interaction", "loginStatus":"${loginStatus}", "actionType":"Header Link Click", "clickText":"${accountLinklabel}", "linkType":"internal", "linkUrl":"${linkUrl}", "moduleName":"Navigation", "pageName":"${pageTitle}", "inPageLocation":"top", "userType":"${rollType}" }`}>
				<span className="d-none d-md-block"
					data-analytics={`{"event":"Navigation_interaction", "loginStatus":"${loginStatus}", "actionType":"Header Link Click", "clickText":"${accountLinklabel}", "linkType":"internal", "linkUrl":"${linkUrl}", "moduleName":"Navigation", "pageName":"${pageTitle}", "inPageLocation":"top", "userType":"${rollType}" }`}>
						{accountLinklabel}
				</span>
				<span className="icon"></span>
      		</Dropdown.Toggle>
			<Dropdown.Menu>
				<div className="popup">
					<button className="close-button" aria-label="Hide" onClick={ hideAccountPanel} ></button>
					<CurrentAccountpanel />
				</div>
			</Dropdown.Menu>
		</Dropdown>
	);
}

export default AccountPanel;
